function getUrl() {
  return location.origin + "/meeting/api/";
}

const baseUrl = process.env.NODE_ENV !== 'production' ? 'http://192.168.1.80:8080/meeting/api/' : getUrl();
const prefix = process.env.NODE_ENV !== 'production' ? '/' : '/meeting/m/';

export default {
  BASE_URL: baseUrl,
  PREFIX: prefix,
  HF_LOGIN_SHOW: 'HF_LOGIN_SHOW',
  RUN_ANIMATIONS: 'RUN_ANIMATIONS',
  CURRENT_USERID: 'CURRENT_USERID',
  HF_LANGUAGE: 'hf_language',
  SESSION_ID: 'SESSION_ID',

  HF_MEETING_ALWAYS_ON: 'HF_MEETING_ALWAYS_ON',
}



// WEBPACK FOOTER //
// ./src/utils/constants/common.js